<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <v-card>
          <v-card-title>
            <v-subheader>Since Date:</v-subheader>
            <v-menu
              ref="menuDate"
              :close-on-content-click="false"
              v-model="menuDate"
              :nudge-right="40"
              :return-value.sync="sinceDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="sinceDate"
                label="Pick a start date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="sinceDate" @input="$refs.menuDate.save(sinceDate)"></v-date-picker>
            </v-menu>
            <v-subheader>Status:</v-subheader>
            <v-select
              v-model="status"
              :items="statuses"
            ></v-select>
          </v-card-title>
        </v-card>
        <v-expansion-panel class="mt-4">
          <p class="ma-4" v-if="!loading && !error && reports.length == 0">No Report Found</p>
          <v-expansion-panel-content v-for="report in reports" v-if="status=='All' || status.toLowerCase() == report.status">
            <div slot="header"> <v-container class="pa-0"><v-layout row><div>{{ moment(report.createdAt).format('MM/DD/YYYY H:mm:ss z') }} - [{{ report.complaintCategory }}] | Message: "{{ report.message }}"</div><v-spacer></v-spacer><div class="pr-3">{{ report.status.toUpperCase() }}</div></v-layout></v-container></div>
            <v-card>
              <v-card-text>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>ID:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.id }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.id)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Ad Unit:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.adUnit }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Ad Size:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.adSize }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Country:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.country }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Device:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.deviceCategory }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Advertiser ID:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.advertiserId }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.advertiserId)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Campaign ID:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.campaignId }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.campaignId)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Line Item ID:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.lineItemId }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.lineItemId)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Creative ID:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.creativeId }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.creativeId)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile class="code-tile">
                    <v-list-tile-action class="list-tile-label">
                      <div>Ad HTML:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-sub-title class="ma-1" :style="{ height: '100%' }"><code style="width:100%;height:100%; overflow-y:scroll;overflow-wrap:break-word">{{ report.adHtml }}</code></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="preview(report.adHtml, report.adSize.split('x')[0], report.adSize.split('x')[1])" :style="{ cursor: 'pointer'}">
                      <v-icon>visibility</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-action @click.stop="copy(report.adHtml)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>User Agent:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.detectedUserAgent }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.detectedUserAgent)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Window Size:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.windowSize }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Div ID:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.divId }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Page Title:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.pageTitle }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Page URL:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.pageUrl }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.pageUrl)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action class="list-tile-label">
                      <div>Referrer:</div>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ report.referrer }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action @click.stop="copy(report.referrer)" :style="{ cursor: 'pointer'}">
                      <v-icon>file_copy</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>

                  <v-divider inset></v-divider>
                </v-list>
              </v-card-text>
              <v-card-actions class="pr-5 pt-0 pb-5">
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="report.status=='new'" @click.stop="archiveReport(report)">Archive</v-btn>
                <v-btn color="primary" v-if="report.status=='archived'" @click.stop="renewReport(report)">Change as New</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
          <v-progress-circular color="primary" indeterminate class="ma-4" v-if="loading"></v-progress-circular>
          <p class="ma-4" v-if="!loading && error">Something Went Wrong. Check Your Internet.</p>
          <p class="ma-4" v-if="!loading && !error && reports.length > 0 && !hasMore">No More Report</p>
        </v-expansion-panel>
        <v-btn class="mt-3" v-if="!loading && !error && hasMore" @click.stop="getMoreReports()">Load More</v-btn>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { isLoggedIn } from '../utils/auth';
import { getReports, archiveReport, renewReport } from '../models/reports';
import preview from '../utils/preview';

export default {
  name: 'dashboard',
  data() {
    return {
      reports: '',
      sinceDate: null,
      status: 'New',
      statuses: ['New', 'Archived'],
      menuDate: false,
      loading: true,
      error: false,
      hasMore: false,
    };
  },
  computed: {
    parsedSinceDate: function () {
      if (this.sinceDate == null) { return null; }
      return this.moment(this.sinceDate);
    },
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    },
    getReports() {
      var that = this;
      this.loading = true;
      this.error = false;
      this.reports = '';
      getReports(this.parsedSinceDate, this.status).then((reports) => {
        that.hasMore = reports.length > 0;
        that.reports = reports; //.sort(function(a, b) { return a.createdAt - b.createdAt; }).reverse();
      }).catch(function (error) {
        that.error = true;
        that.hasMore = false;
      }).then(function () {
        that.loading = false;
      });
    },
    getMoreReports() {
      var that = this;
      this.loading = true;
      this.error = false;
      getReports(this.parsedSinceDate, this.status, this.reports.filter(function(report) { return report.status == that.status.toLowerCase(); }).pop()).then((reports) => {
        that.hasMore = reports.length > 0;
        reports = reports; //.sort(function(a, b) { return a.createdAt - b.createdAt; }).reverse();
        that.reports.push(...reports);
      }).catch(function (error) {
        that.error = true;
        that.hasMore = false;
      }).then(function () {
        that.loading = false;
      });
    },
    archiveReport(report) {
      archiveReport(report).then((new_report) => {
        report.status = 'archived';
      });
    },
    renewReport(report) {
      renewReport(report).then((new_report) => {
        report.status = 'new';
      });
    },
    copy(text) {
      var el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style = {position: 'absolute', left: '-9999px'};
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
    preview(html, width, height) {
      preview(html, width, height);
    },
  },
  watch: {
    sinceDate (val) {
      this.getReports();
    },
    status (val) {
      this.getReports();
    }
  },
  mounted() {
    this.getReports();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.list-tile-label {
  min-width: 112px;
}
.v-divider--inset:not(.v-divider--vertical) {
  margin-left: 128px;
  max-width: calc(100% - 128px);
}
</style>

<style>
.code-tile > .v-list__tile {
  height: 480px;
}
</style>